import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useNavigate, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';

import { ARCHIVE_PROJECT } from '../../apis/project';
import Button from '../atoms/button';

const propTypes = {
  openToggle: PropTypes.bool.isRequired,
  handleArchiveClose: PropTypes.func.isRequired,
};

const ArchiveProjectDialog = ({ openToggle, handleArchiveClose }) => {
  const params = useParams();
  const navigate = useNavigate();
  const [archiveProject] = useMutation(ARCHIVE_PROJECT);
  const eventhandler = async (id) => {
    const variables = {
      input: {
        id: parseInt(id, 10),
      },
    };
    const { data, loading, error } = await archiveProject({
      variables,
    });
    if (data && !loading && !error) {
      navigate('/');
    }
  };
  return (
    <Dialog
      className="custom-modal-dialog confirmation-modal-dialog"
      open={openToggle}
      onClose={handleArchiveClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent className="dialog-content">
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to Archive this project?
        </DialogContentText>
      </DialogContent>
      <DialogActions className="dialog-actions">
        <Button primary outlined onClick={handleArchiveClose}>Cancel</Button>
        <Button primary onClick={() => eventhandler(params.id)} autoFocus>Archive</Button>
      </DialogActions>
    </Dialog>
  );
};

ArchiveProjectDialog.propTypes = propTypes;
export default ArchiveProjectDialog;
